import type SearchHint from '~/type/SearchHint'

export default function (el: any): SearchHint {
  return {
    name: el,
    path: `/search/?q=${el}`,
  }
}
